import Image from "next/image";
import { Button } from "@/components/ui/button";

export default function FAQsHeroSection() {
  return (
    <div className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] lg:min-h-screen overflow-hidden">
      {/* Background Image */}
      <Image
        src="/image/FAQs/hero-section.jpg"
        alt="Wheels display"
        fill
        className="object-cover"
        priority
      />
      
      {/* Gradient Overlay */}
      <div 
        className="absolute inset-0" 
        style={{ 
          background: "linear-gradient(287.56deg, rgba(0, 0, 0, 0) 22.62%, rgba(0, 0, 0, 0.6) 45.09%)" 
        }}
      />

      {/* Content */}
      <div className="absolute inset-0 flex items-end">
        <div className="px-4 sm:px-6 md:px-8 lg:px-20 pb-8 sm:pb-12 md:pb-16 lg:pb-20">
          <div className="max-w-[280px] sm:max-w-[400px] md:max-w-[600px] lg:max-w-[900px]">
            {/* Label */}
            <p className="font-plus-jakarta text-[10px] sm:text-xs md:text-sm lg:text-base font-medium text-white/80 mb-1 sm:mb-2 md:mb-3 lg:mb-4">
              FAQS
            </p>

            {/* Heading */}
            <h1 className="font-plus-jakarta text-lg sm:text-xl md:text-3xl lg:text-5xl font-bold text-white mb-2 sm:mb-3 md:mb-4 lg:mb-6 leading-tight">
              ANSWERS TO YOUR WHEEL QUESTIONS
            </h1>

            {/* Description */}
            <p className="font-plus-jakarta text-xs sm:text-sm md:text-base lg:text-lg text-white/80 mb-4 sm:mb-5 md:mb-6 lg:mb-8">
              Find clear answers about buying, selling, shipping, and delivery at WheelTox.
            </p>

            {/* CTA Button */}
            <Button
              className="font-plus-jakarta font-bold bg-primary hover:bg-primary/90 text-white h-10 sm:h-11 md:h-12 lg:h-14 px-4 sm:px-5 md:px-6 lg:px-8 rounded-xl text-xs sm:text-sm md:text-base cursor-pointer"
              onClick={() => {
                document.getElementById('faq-content')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Still Have Questions?
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
